import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const CheckCircle = (): JSX.Element => <CheckCircleIcon fontSize="inherit" />;

export default CheckCircle;
